import { generateTypes } from '../../utils/HttpReducerHelper';

const tagsData = generateTypes('MONITOR_CLIENT', 'TAGS_DATA');
const addNewTag = generateTypes('MONITOR_CLIENT', 'ADD_NEW_TAG');
const removeTag = generateTypes('MONITOR_CLIENT', 'REMOVE_TAG');
const editTag = generateTypes('MONITOR_CLIENT', 'TAG_EDIT');
const assignTag = generateTypes('MONITOR_CLIENT', 'ASSIGN_TAG');
const unassignTag = generateTypes('MONITOR_CLIENT', 'UNASSIGN_TAG');

export { tagsData, addNewTag, removeTag, editTag, assignTag, unassignTag };
